import Vue from 'vue'
import App from './App.vue'
import router from './router'
import auth from './auth'
import store from './store/store'
import axios from 'axios'
import moment from 'moment'
/* tslint:disable:no-var-requires */
const PortalVue = require('portal-vue')
const infiniteScroll =  require('vue-infinite-scroll')

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

import './includes/vue-filters'
import './includes/vue-directives'

// CSS
import '@fortawesome/fontawesome-free/css/all.css'
import 'vue-datetime/dist/vue-datetime.css'
import 'vue-swipe-actions/dist/vue-swipe-actions.css'

Vue.config.productionTip = false

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
}

axios.defaults.baseURL = process.env.API_URL

axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  const code = error.response.status
  switch (code) {
    case 401:
      auth.logout()
      break
    default:
  }
  return Promise.reject(error)
})

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://a117e719687d438aa45d17fcc2379da4@sentry.io/182457',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
  })
}

Vue.use(PortalVue)
Vue.use(infiniteScroll)

Vue.prototype.moment = moment

export default Vue

new Vue({
  router,
  store,
  created() {
    auth.init()
  },
  render: (h) => h(App),
}).$mount('#app')
